import Component from './signUp'

export default Component